/**
 *  Questions and answers
 * 
 */
let questions = [
  {
    text: `Whilst I accept your travel costs do represent a direct cost to working from the office, ultimately, you made the decision to move to Stevenage`,
    correct: true
  },
  {
    text: `Believe me when I say I am not unsympathetic to the financial situation you’ve found yourself in`,
    correct: true
  },
  {
    text: `So, it got me thinking about how best to help you out, and it seems that now could be the perfect opportunity to start looking at developing the dropship websites we tentatively spoke about earlier this year`,
    correct: true
  },
  {
    text: `I understand exactly what you’re going through. When my wife and I bought our first flat, within a year of moving in and pretty much out of the blue, we were being asked to stump up an extra £10,000. We cut out all unnecessary spending and both my wife and I got Saturday jobs.`,
    correct: true
  },
  {
    text: `I also sold all of my fishing tackle, my mountain bike, and a stereo system I have been saving up for and building over the previous two years`,
    correct: true
  },
  {
    text: `As I am sure you know, fishing equipment really isn't cheap`,
    correct: false
  },
  {
    text: `Like you, I know I could certainly do with some additional income, particularly at the moment - All we need to do is find products we want to sell`,
    correct: true
  },
  {
    text: `I know times are difficult, but with COVID-19, the office can't also afford to build up debt`,
    correct: false
  },
  {
    text: `Whilst you may well disagree with me over the impact this has had, I would suggest that’s more because you’re thinking about it from a purely individual perspective and not as the one who has been negatively affected`,
    correct: true
  },
  {
    text: `Whilst you may be working on one or two projects at any one time, I am plate spinning a number of smaller tasks which require me to be far more informed and reactive`,
    correct: true
  },
  {
    text: `I am a plate spinner juggling a range of small tasks at any one time`,
    correct: false
  },
  {
    text: `All we need to do is find products we want to sell`,
    correct: false
  },
  {
    text: `I just don't think that everyone appreciates or quite fathom how many small tasks we get from customers on a day-to-day basis`,
    correct: false
  },
  {
    text: `You have failed to consider the role of my job in the company and the variance of daily communications I am involved in`,
    correct: true
  },
  {
    text: `Having had to man the office on my own for over 4 months, not being able to take any holiday or even more than 10 minutes lunch, I would very much say that there has been a negative impact, on me at least`,
    correct: true
  },
  {
    text: `I don't want to sound dismissive, but obviously none of this is the fault of the company, and we just can't afford to keep working remote and working so inefficiently`,
    correct: false
  },
  {
    text: `I’m not actually asking for much`,
    correct: true
  },
  {
    text: `A lot of customers just don't have a scoobies about contacting us out of the office, so we really need someone in the office throughout the day`,
    correct: false
  },
  {
    text: `When you change projects, please let me know what you’re moving onto, that way I can then provide customers with an informed update with regard to what phase their project is in`,
    correct: true
  },
  {
    text: `I am now already back to working over the weekend (this Saturday I worked 3 hours and yesterday I worked 11 hours)`,
    correct: true
  },
  {
    text: `I am not asking you to come in weekends or anything unreasonable like that`,
    correct: false
  },
  {
    text: `I've worked every weekend for the last 4 months, and quite simply I need everyone back in the office to pick up some of the slack`,
    correct: false
  },
  {
    text: `I think in the short term at least we’ll remain in Hertford. I’m not actually against staying in a town, it’s just my research shows that you get more for your money in out-of-town locations.`,
    correct: true
  },
  {
    text: `I have been researching offices to move to, and carefully analysing what gives bang-for-buck, and town centers just don't seem cut it. So we will need to be remote. If you can learn to drive, that will solve a lot of these issues`,
    correct: false
  },
  {
    text: `If there’s anything mentioned above you want to discuss further, please give me a call so that we can talk it through rather than getting into anymore long winded emails – I could have cut my 11 hour day to just 9 hours yesterday if it wasn’t for this`,
    correct: true
  },
  {
    text: `Again I don't want to sound dismissive, but ultimately it's not unreasonable to expect worker who are paid for a job to turn up, and that does sometimes include commuting`,
    correct: false
  },
  {
    text: `With regard to the financial side of your argument, I don’t really think it’s fair or right to use that as reason not to come back to the office, as it’s in no way linked to the reason you are currently working from home.`,
    correct: true
  },
  {
    text: `I've sold a lot of old fishing gear in the past, and sometimes things like that can help release some cashflow. Is this something you've considered?`,
    correct: false
  },
  {
    text: `My Saturday job really helped me during those years. And I am not saying get a job at Tesco at all, but even without that council bill, extra income never hurts`,
    correct: false
  },
  {
    text: `I have to totally disagree with your comments about my communication being linear`,
    correct: true
  },
  {
    text: `Slack is a linear communication tool as it is one dimensional and stiffers dynamic communication and flowing debate, ultimately restricting progression`,
    correct: true
  },
  {
    text: `Whilst you may be working on one or two projects at any one time`,
    correct: true
  },
  {
    text: `I haven't been fishing in months`,
    correct: false
  },
  {
    text: `My lunchtimes are only 10 minutes before a customer calls to complain about something`,
    correct: false
  },
  {
    text: `I think you are focusing far too much on your own position, and not the needs of the company as a whole`,
    correct: false
  },
  {
    text: `I would like to see a shift to more phone/video calls for communications that don’t need to have a searchable record, that need discussion, or where it’s deemed quicker to simply talk than it would be typing back and forth.`,
    correct: true
  },
  {
    text: `I am also extremely conscious that having now let a staff member go, it will be down to me to pick up the slack`,
    correct: true
  },
  {
    text: `I am now doing the work of two people`,
    correct: false
  },
  {
    text: `I am now doing my job, and a bit of everyone else's`,
    correct: false
  },
  {
    text: `It’s often difficult for me to answer every question that is asked`,
    correct: true
  }
];

/**
 *  Export randomQuestion closure function
 * 
 */
export default function randomQuestion(){
  let random = q => q[Math.floor(Math.random() * q.length)];

  return random(questions);
}
